export const renderCarouselIcons = (swiper: any, current: any, total: any) => {
  let el = `<div class="custom-carousel-bullets">`;

  for (let i = 0; i < total; i++) {
    if (current == i + 1) {
      el =
        el +
        `
          <svg
            width="15"
            height="8"
            viewBox="0 0 15 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="15" height="8" rx="4" fill="#69EAFF" />
          </svg>
        `;
    } else {
      el =
        el +
        `
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="4" cy="4" r="4" fill="#3F6291" />
          </svg>
        `;
    }
  }

  el = el + "</div>";

  return el;
};

export const CarouselArrow = ({
  id,
  direction = "left",
  disabled = false,
  onClick,
}: any) => (
  <div id={id} onClick={onClick}>
    <svg
      className={`${direction === "right" ? "rotate-180" : ""} hover:cursor-pointer`}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={disabled ? "0.5" : "1"}>
        <rect width="28" height="28" rx="8" fill="#001854" />
        <path
          d="M10.452 14C10.452 14.1444 10.4791 14.2845 10.5333 14.4203C10.5874 14.5561 10.6597 14.6687 10.7499 14.7583L15.7333 19.7416C15.9319 19.9402 16.1847 20.0396 16.4916 20.0396C16.7985 20.0396 17.0513 19.9402 17.2499 19.7416C17.4485 19.543 17.5479 19.2902 17.5479 18.9833C17.5479 18.6764 17.4485 18.4236 17.2499 18.225L13.0249 14L17.2499 9.77497C17.4485 9.57636 17.5479 9.32358 17.5479 9.01663C17.5479 8.70969 17.4485 8.45691 17.2499 8.2583C17.0513 8.05969 16.7985 7.96038 16.4916 7.96038C16.1847 7.96038 15.9319 8.05969 15.7333 8.2583L10.7499 13.2416C10.6416 13.35 10.5647 13.4673 10.5192 13.5937C10.4737 13.7201 10.4513 13.8555 10.452 14Z"
          fill="#79BFFF"
        />
      </g>
    </svg>
  </div>
);
